import { render } from "./NotificationBase.vue?vue&type=template&id=af046ad4&scoped=true"
import script from "./NotificationBase.vue?vue&type=script&lang=js"
export * from "./NotificationBase.vue?vue&type=script&lang=js"

import "./NotificationBase.vue?vue&type=style&index=0&id=af046ad4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-af046ad4"]])

export default __exports__